(function() {
  var root = document.querySelector('[data-firefly-product-detail]');
  if (!root) return;

  function trimTrailingBreaks(node) {
    if (!node) return;

    while (node.lastChild) {
      var lastChild = node.lastChild;

      if (lastChild.nodeType === Node.TEXT_NODE && !lastChild.textContent.trim()) {
        node.removeChild(lastChild);
        continue;
      }

      if (lastChild.nodeType === Node.ELEMENT_NODE && lastChild.tagName === 'BR') {
        node.removeChild(lastChild);
        continue;
      }

      break;
    }
  }

  root.querySelectorAll('.firefly-product-detail__spec-value').forEach(function(value) {
    trimTrailingBreaks(value);
    value.querySelectorAll('p, div, span, li').forEach(trimTrailingBreaks);
  });

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-product-detail-tab]'));
  if (!tabs.length) return;

  var panels = tabs
    .map(function(tab) {
      var id = tab.getAttribute('href');
      return id && id.charAt(0) === '#' ? document.querySelector(id) : null;
    })
    .filter(Boolean);

  var pageWrapper = document.querySelector('.page-wrapper');
  var scrollContainer = pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight
    ? pageWrapper
    : window;

  var isSpecialDetail = root.classList.contains('firefly-product-special-detail');
  var specialTabs = isSpecialDetail ? root.querySelector('.firefly-product-detail__tabs') : null;
  var specialTabsScrollRaf = 0;

  function updateSpecialTabsStickyState() {
    specialTabsScrollRaf = 0;

    if (!specialTabs) return;

    var isDesktop = window.matchMedia('(min-width: 990px)').matches;
    var rootRect = root.getBoundingClientRect();
    var tabsHeight = specialTabs.offsetHeight || 0;
    var isStuck = isDesktop && rootRect.top <= headerHeight() && rootRect.bottom > tabsHeight;
    var wasStuck = root.hasAttribute('data-tabs-stuck');

    root.toggleAttribute('data-tabs-stuck', isStuck);
    document.body.classList.toggle('firefly-special-detail-tabs-stuck', isStuck);

    if (wasStuck !== isStuck) {
      window.dispatchEvent(new CustomEvent('firefly:special-tabs-sticky-change', {
        detail: { isStuck: isStuck }
      }));
    }
  }

  function requestSpecialTabsStickyUpdate() {
    if (specialTabsScrollRaf) return;
    specialTabsScrollRaf = window.requestAnimationFrame(updateSpecialTabsStickyState);
  }

  function headerHeight() {
    return window.matchMedia('(max-width: 989px)').matches ? 50 : 80;
  }

  function stickyOffset() {
    var tabsHeight = root.querySelector('.firefly-product-detail__tabs').offsetHeight || 0;
    var visibleHeaderHeight = specialTabs && root.hasAttribute('data-tabs-stuck') ? 0 : headerHeight();
    return visibleHeaderHeight + tabsHeight + 12;
  }

  if (specialTabs) {
    scrollContainer.addEventListener('scroll', requestSpecialTabsStickyUpdate, { passive: true });
    window.addEventListener('resize', requestSpecialTabsStickyUpdate, { passive: true });
    requestSpecialTabsStickyUpdate();
  }

  function setActiveTab(panelId) {
    tabs.forEach(function(tab) {
      tab.classList.toggle('is-active', tab.getAttribute('href') === '#' + panelId);
    });
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(event) {
      var targetId = tab.getAttribute('href');
      var target = targetId && document.querySelector(targetId);
      if (!target) return;

      event.preventDefault();
      var currentTop = scrollContainer === window ? window.pageYOffset : scrollContainer.scrollTop;
      var containerTop = scrollContainer === window ? 0 : scrollContainer.getBoundingClientRect().top;

      scrollContainer.scrollTo({
        top: target.getBoundingClientRect().top - containerTop + currentTop - stickyOffset(),
        left: 0,
        behavior: 'smooth'
      });
      setActiveTab(target.id);
      history.replaceState(null, '', targetId);
    });
  });

  var accessorySlider = root.querySelector('[data-accessories-slider]');
  if (accessorySlider) {
    var accessoryTrack = accessorySlider.querySelector('[data-accessories-track]');
    var accessorySlides = Array.prototype.slice.call(accessorySlider.querySelectorAll('[data-accessories-slide]'));
    var accessoryDots = Array.prototype.slice.call(accessorySlider.querySelectorAll('[data-accessories-dot]'));
    var accessoryPrev = accessorySlider.querySelector('[data-accessories-prev]');
    var accessoryNext = accessorySlider.querySelector('[data-accessories-next]');

    function accessoryIndex() {
      if (!accessoryTrack || !accessorySlides.length) return 0;
      var trackLeft = accessoryTrack.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      accessorySlides.forEach(function(slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function setAccessoryDot(index) {
      accessoryDots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function scrollAccessoryTo(index) {
      if (!accessoryTrack || !accessorySlides[index]) return;
      var trackPaddingLeft = parseFloat(getComputedStyle(accessoryTrack).paddingLeft) || 0;
      accessoryTrack.scrollTo({
        left: accessorySlides[index].offsetLeft - accessoryTrack.offsetLeft - trackPaddingLeft,
        behavior: 'smooth'
      });
      setAccessoryDot(index);
    }

    accessoryDots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        scrollAccessoryTo(index);
      });
    });

    if (accessoryPrev) {
      accessoryPrev.addEventListener('click', function() {
        scrollAccessoryTo(Math.max(0, accessoryIndex() - 1));
      });
    }

    if (accessoryNext) {
      accessoryNext.addEventListener('click', function() {
        scrollAccessoryTo(Math.min(accessorySlides.length - 1, accessoryIndex() + 1));
      });
    }

    if (accessoryTrack) {
      accessoryTrack.addEventListener('scroll', function() {
        window.requestAnimationFrame(function() {
          setAccessoryDot(accessoryIndex());
        });
      }, { passive: true });
    }
  }

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) setActiveTab(entry.target.id);
    });
  }, {
    rootMargin: '-' + stickyOffset() + 'px 0px -55% 0px',
    threshold: 0.01
  });

  panels.forEach(function(panel) {
    observer.observe(panel);
  });
})();
